import React from 'react';

const Footer = () => {
  return <div className="flex justify-center gap-3 border-t border-gray-300 p-2 text-center">
    <button className="tinylytics_kudos">❤️ 0</button>
    <p>{(new Date()).getFullYear()} Mini Calendar Generator by <a href="https://vmac.ch">vmac.ch</a><span className="pl-2 text-gray-500">{process.env.REACT_APP_VERSION}</span></p>
  </div>
};

export default Footer;